module.exports = require('./_shared')('native-function-to-string', Function.toString);



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/_function-to-string.js
 ** module id = 548
 ** module chunks = 0
 **/